import React from 'react';

interface MapPopupContentProps {
    title?: string;
    text?: React.ReactNode;
    minWidth?: string | number;
    padding?: string | number;
    accentColor?: string;
}

export const MapPopupContent: React.FC<MapPopupContentProps> = ({
    title,
    text = '',
    minWidth = 150,
    padding = 12,
    accentColor,
}) => (
    <div
        className="popup-container"
        style={{
            minWidth,
            padding,
            border: accentColor ? `2px solid ${accentColor}` : undefined,
            boxShadow: accentColor ? `0 2px 6px ${accentColor}33` : undefined,
        }}
    >
        {!title ? null : <div className="popup-title">{title}</div>}
        <div className="popup-text">{text}</div>
    </div>
);
